// ═══════════════════════════════════════════════════════════════════════════════
//  LOS AUDIOS — CÓMO SE ENCHUFAN
//
//  No hay que tocar código para añadirlos. Se dejan los ficheros en
//  `./audios/` con este nombre exacto y aparecen solos:
//
//      audios/recorrido-saludo.mp3      la bienvenida
//      audios/recorrido-coach.mp3
//      audios/recorrido-gimnasio.mp3    uno por cada `id` de PASOS,
//      audios/recorrido-lecciones.mp3   tal cual esta escrito en guion.js
//      …
//      audios/recorrido-cierre.mp3      el final
//
//  ── POR QUÉ POR CONVENCIÓN Y NO CON UN `import` POR PASO ───────────────────
//  Un `import` de un fichero que todavía no existe TUMBA la compilación. Con
//  once pasos, eso significa que el recorrido no se puede desplegar hasta que
//  estén las once grabaciones — y obliga a editar este fichero cada vez que se
//  añade una, que es exactamente la clase de paso que se olvida.
//
//  Así, en cambio: el que falte no suena y ya está. Se puede grabar de una en
//  una, probar cómo queda, y desplegar en cualquier momento. Cuando aparezca el
//  fichero, la voz aparece con él.
//
//  ── Y UNA ADVERTENCIA PARA EL DÍA DE MAÑANA ────────────────────────────────
//  Si se cambia el TEXTO de un paso, hay que volver a grabar SU audio. Si no,
//  la pantalla dirá una cosa y la voz otra, y nadie se dará cuenta porque nadie
//  vuelve a escucharlos enteros. Cambiar el texto sin regrabar es peor que no
//  tener audio.
// ═══════════════════════════════════════════════════════════════════════════════

const AUDIOS = import.meta.glob('./audios/*.mp3', { eager: true, import: 'default' });

/** La grabación de ese paso, o `null` si todavía no se ha hecho. */
export function audioDe(id) {
    return AUDIOS[`./audios/recorrido-${id}.mp3`] ?? null;
}

/** Cuántas grabaciones hay puestas. Lo usa la batería para informar, no para fallar. */
export const AUDIOS_PUESTOS = Object.keys(AUDIOS).length;

